<app-nav-bar *ngIf="checkUrl(router.url)"></app-nav-bar>
<section class="main_content dashboard_part large_header_bg" [ngClass]="{'padding-login': !checkUrl(router.url), 'full_main_content' : menuToogle == true }">
    <app-header *ngIf="checkUrl(router.url)"></app-header>
    <div *ngIf="ambienteDev" class="tagert">Ambiente de desenvolvimento v {{version}}</div>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</section>